import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { Card,Table,Placeholder } from 'react-bootstrap';
const DepartmentPhDProgram = ({pageData}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Faculties,setFaculties]=useState([]);
    const[Departments,setDepartments]=useState([]);
    useEffect(()=>
    {
        const DepartmentDetails = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"departments/details/"+pageData.sp_sd_id);
                const result = await response.json();
                setDepartments(result);
                if( global.config.IsPrint === true ) { console.info('DepartmentDetails : Result',result); }
            } catch (error) 
            {
                console.error('DepartmentDetails : Error', error.message);
            }
        };
        const FacultyByTypeAndDepartment = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"faculty/byUserTypeAndDepartment/1/"+pageData.sp_sd_id);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(
                            e => fetch(global.config.API_URL + "userDetails/byUserField/" + e.su_id + "/8")
                                .then(ud => ud.json())
                        )
                    ).then(uds => {
                        uds.forEach((el, i) => {
                            result[i].udDetails = (el.length > 0) ? el[0] : [];
                        });
                        setFaculties(result);
                    }).catch(error => 
                    {
                        console.error('ResearchRegulationsLatest File :', error);
                    });
                }
                if( global.config.IsPrint === true ) { console.info('FacultyByTypeAndDepartment : Result',result); }
            } 
            catch (error) 
            {
                console.error('FacultyByTypeAndDepartment : Error', error.message);                
            }
            finally
            {
                setLoading(false);
            }
        };
        DepartmentDetails();
        FacultyByTypeAndDepartment();
    },[pageData])
    return (
        <React.Fragment>
        {Departments.map((sd,index)=>(
        <Card className='mb-4' key={index}>
            <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                {appLanguage === 'hi' ? 'पीएच.डी. कार्यक्रम' : 'PH.D. PROGRAM AT'} {appLanguage === 'hi' ? sd.sd_fullname_hi || sd.sd_fullname : sd.sd_fullname}
            </Card.Header>
            <Card.Body dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? sd.sd_phd_program_hi || sd.sd_phd_program : sd.sd_phd_program}}></Card.Body>
        </Card>
        ))}
        <Card className='mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                {appLanguage === 'hi' ? "प्रमुख अनुसंधान क्षेत्र" : "MAJOR RESEARCH AREAS"}
            </Card.Header>
            <Card.Body>
                <p>{appLanguage === 'hi' ? "प्रासंगिक अनुसंधान क्षेत्र में रिक्तियों की उपलब्धता के अधीन निम्नलिखित विषयों में पीएचडी कार्यक्रम की पेशकश की जा रही है:" : "The Ph.D Program is being offered in the following disciplines subject to the availability of vacancy in the relevant research field:"}</p>
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                    <thead>
                    <tr>
                        <th className="w-25">{appLanguage === 'hi' ? "फैकल्टी का नाम" : "Name of Faculty"}</th>
                        <th>{appLanguage === 'hi' ? "अनुसंधान क्षेत्र" : "Research Areas"}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {isLoading ? (
                        <React.Fragment>
                        {[...Array(10)].map((_,index) => (
                            <tr key={index}> 
                                <th className="table-success"><Placeholder xs={10} bg="success" /></th>
                                <td className="text-center"><Placeholder xs={10} bg="success" /></td>
                            </tr>
                        ))}
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                        {Faculties.map((su,index)=>(
                            <tr key={index}>
                                <th className="table-success">
                                    <NavLink to={appLanguage === 'hi' ? `/प्रोफ़ाइल/विवरण/${su.su_htaccess_hi || su.su_htaccess}` : `/profile/details/${su.su_htaccess}`} target='_blank' rel="noopener noreferrer">
                                        {appLanguage === 'hi' ? su.su_name_hi || su.su_name : su.su_name}
                                    </NavLink>
                                </th>
                                <td dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? su.udDetails.ud_details_hi || su.udDetails.ud_details : su.udDetails.ud_details }}></td>
                            </tr>
                        ))}
                        </React.Fragment>
                    )}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    </React.Fragment>
    );
}
export default DepartmentPhDProgram;
